<script setup lang="ts">
import '@assets/css/style.css';

import { useUrqlStore } from '@stores/useUrqlStore';
import { useI18n } from 'vue-i18n';
import { mergeContentPages, createLocaleMessage } from '@core-utils/cms';
import { fetchCmsPackage } from '@core-queries/cmsPackage';
import { fetchCmsLanguages } from '@core-queries/cmsLanguages';
import { CmsLanguage, CmsPage } from '@core-types/cms';

const { gqlClient } = toRefs(useUrqlStore());
const { setLocaleMessage } = useI18n();

const pagesRef = ref<CmsPage[]>([]);
const languagesRef = ref<CmsLanguage[]>([]);

const initiateLanguages = async () => {
  const promises = [
    fetchCmsLanguages(gqlClient.value),
    fetchCmsPackage(gqlClient.value, { id: import.meta.env.VITE_CMS_PACKAGE_ID }),
    fetchCmsPackage(gqlClient.value, { id: 4 }),
  ] as const;
  const [languages, intermediairsContent, componentContent] = await Promise.all(promises);

  languagesRef.value = languages.cmsLanguages;

  const contentPages = mergeContentPages(intermediairsContent.cmsPackage.pages, componentContent.cmsPackage.pages);
  pagesRef.value = contentPages;

  for (const language of languagesRef.value) {
    const content = createLocaleMessage(pagesRef.value, language.id);
    setLocaleMessage(language.code, content);
  }
};

onMounted(async () => {
  await initiateLanguages();
});
</script>

<template>
  <NuxtPage />
</template>
